import $ from 'jquery';
import modaal from 'modaal';
import * as CONST from '../utils/constants';

class Modal {
    constructor() {
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $('.js-inline-modal').modaal();

        $('.video').modaal({
            type: 'video',
            width: 930
        });

        $(document).on('click', '.js-video-modal', (event) => {
            let contentSource = $(event.currentTarget).attr('data-modaal-content-source');
            $(event.currentTarget).modaal({
                type: 'video',
                content_source: contentSource,
                start_open: true,
                after_open: () => {
                    let iframe = $('iframe.modaal-video-frame');
                    iframe.attr('allow', 'autoplay;');
                    iframe.attr('src', contentSource);
                    let closeButton = $('#modaal-close');
                    closeButton.insertBefore(closeButton.prev());
                    closeButton.addClass('visible');
                }
            });
        });

        $(document).on('click', '.js-video-modal-local', (event) => {
            let contentSource = $(event.currentTarget).attr('data-modaal-content-source');
            $(event.currentTarget).modaal({
                type: 'inline',
                content_source: contentSource,
                start_open: true
            });
        });        
    }
}

export default Modal;

$(() => {
    const modal = new Modal();
    modal.init();
});